import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/auth/login/page";
import Register from "../pages/auth/register/page";
import WriterProfile from "../pages/profile/writer/page";
import ReaderProfile from "../pages/profile/reader/page";
import SubmitStory from "../pages/submit/page";
import StoriesPage from "../pages/stories/page";
import WritersPage from "../pages/writers/page";
import CommunityPage from "../pages/community/page";
import TopRankedPage from "../pages/top-ranked/page";
import AboutPage from "../pages/about/page";
import GuidelinesPage from "../pages/guidelines/page";
import ContactPage from "../pages/contact/page";
import ProtectedRoute from "../components/feature/ProtectedRoute";
import { lazy } from "react";

const StoryPage = lazy(() => import("../pages/story/page"));
const PublicWriterProfile = lazy(() => import("../pages/profile/writer/public/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/guidelines",
    element: <GuidelinesPage />,
  },
  {
    path: "/stories",
    element: <StoriesPage />,
  },
  {
    path: "/writers",
    element: <WritersPage />,
  },
  {
    path: "/community",
    element: <CommunityPage />,
  },
  {
    path: "/top-ranked",
    element: <TopRankedPage />,
  },
  {
    path: "/story/:slug",
    element: <StoryPage />,
  },
  {
    path: "/profile/writer/:id",
    element: <PublicWriterProfile />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/profile/writer",
    element: (
      <ProtectedRoute>
        <WriterProfile />
      </ProtectedRoute>
    ),
  },
  {
    path: "/profile/reader",
    element: (
      <ProtectedRoute>
        <ReaderProfile />
      </ProtectedRoute>
    ),
  },
  {
    path: "/submit",
    element: (
      <ProtectedRoute>
        <SubmitStory />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;